import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=a97ec0d6&scoped=true"
import script from "./SummaryCard.vue?vue&type=script&lang=ts"
export * from "./SummaryCard.vue?vue&type=script&lang=ts"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=a97ec0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97ec0d6",
  null
  
)

export default component.exports